import "./trial-form.css";
import Select from "react-select";

const SalesforceEnv = ({crm, orgType, handleSaleforceEnv,sfUserMessage, sfNonAdminUserMessage}) => {
    crm = crm?.value
    var orgTypeMap = {
      "production": 0,
      "sandbox": 1,
      "sms-magic": 2,
    }
    var selected_org_type = orgTypeMap[orgType];
    console.log("selected_org_type: ", selected_org_type)

    const SALEFORCE_ENV = [
        { label: "Salesforce Production", value: "production" },
        { label: "Salesforce Sandbox", value: "sandbox" },
      ];

    const admin_user_label = () => {
      if (crm === 'sf' && (orgType === 'production' || orgType === 'sandbox')) {
        return (
        <div className="admin-user-label">
            {<label>Please make sure you have admin rights to install and configure apps.
            <a href="https://www.sms-magic.com/docs/salesforce/faq-category/getting-started/" target="_blank" rel="noreferrer">Learn more</a></label>}
        </div>)
      }
      else{
          return ( <div className="admin-user-label"><label> &nbsp; </label> </div>)
      }
    }

    if (crm === "sf") {
        return (
        <div className="col-sm-12 relative-box">
        <label htmlFor="SF_ENV" className="form-label required">Salesforce Environment</label>
        <Select
          className="crm-select"
          options={SALEFORCE_ENV}
          defaultValue={SALEFORCE_ENV[selected_org_type]}
          autosize={true}
          onChange={handleSaleforceEnv}
        ></Select>

        <span>&nbsp;</span>
        {/* Admin user Label */}
        {admin_user_label()}

        <div className="validation-msg-sfadmin">
        {sfNonAdminUserMessage ? <>{sfNonAdminUserMessage}</> : null}
        {sfUserMessage?<>{sfUserMessage}</>:null}
        </div>
        <span>&nbsp;</span>
      </div>);
    }
  }

export default SalesforceEnv;
